<pmt-action-modal [title]="'assignments.communication.editUpdate' | transloco"
    [cancelButtonText]="'modal.cancelButton' | transloco" submitButtonIconCode="''" (submitted)="saveForm()"
    class="custom-modal-limiter" [isSaving]="isLoading">

    <!-- Loading -->
    <ng-container *ngIf="!updateForm">
        <div class="text-center">
            <span>
                <i class="fa-solid fa-spinner fa-spin"></i>
            </span>
        </div>
    </ng-container>

    <!-- Loading Finished -->
    <ng-container *ngIf="updateForm">
        <div class="d-flex flex-column gap-2">

            <div [ngClass]="{'border border-2 border-danger': updateResponse?.isSuccess == false}">
                <form [formGroup]="updateForm">
                    <textarea class="form-control" formControlName="update" rows="3" [disabled]="isLoading"
                        appPreventSpaceAndLineBreak appSanitizeSpaceAndLineBreak></textarea>

                </form>
            </div>
            <p class=" text-danger" *ngIf="!updateResponse?.isSuccess">
                {{updateResponse?.errorMessage}}
            </p>

            <p class="warning text-secondary">
                {{'assignments.communication.editUpdateLineBreakInfo' | transloco}}
            </p>

        </div>
    </ng-container>
</pmt-action-modal>